import React, { useState, useEffect } from 'react'
import { Grid, FormControlLabel, Checkbox, Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  TAG_ID: {
    DOM: 0,
    INTL: 0
  },
  TEST_MODE: {
    DOM: false,
    INTL: false
  }
}

export const AdaptMX = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  VENDOR.ADAPTMX = { ...template, ...VENDOR.ADAPTMX }
  const { ADAPTMX } = VENDOR
  const { TAG_ID, TEST_MODE } = ADAPTMX
  const { DOM: DOM_TAG, INTL: INTL_TAG } = TAG_ID
  const { DOM: DOM_TEST, INTL: INTL_TEST } = TEST_MODE
  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='adaptmx-panel-content'
        id='adaptmx-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>AdaptMX</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table size='small' aria-label='adaptmx-tag-id-table'>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '180px' }}></TableCell>
                  <TableCell>Domestic</TableCell>
                  <TableCell>International</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Tag IDs</Typography></TableCell>
                  <TableCell>
                    <TextField
                      margin='none'
                      value={DOM_TAG}
                      error={errors.PREBID_ADAPTMX_TIDD}
                      helperText={errors.PREBID_ADAPTMX_TIDD && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.ADAPTMX.TAG_ID.DOM = value
                        setErrors({ ...errors, PREBID_ADAPTMX_TIDD: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      margin='none'
                      value={INTL_TAG}
                      error={errors.PREBID_ADAPTMX_TIDI}
                      helperText={errors.PREBID_ADAPTMX_TIDI && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        PREBID.VENDOR.ADAPTMX.TAG_ID.INTL = value
                        setErrors({ ...errors, PREBID_ADAPTMX_TIDI: value.length < LENGTH.min || value.length > LENGTH.max })
                        setOptions({ ...options, PREBID })
                        setAllOptions({ ...allOptions, PREBID })
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <Table size='small' aria-label='adaptmx-test-mode-table'>
              <TableBody>
                <TableRow>
                  <TableCell style={{ width: '180px' }}><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Test Mode</Typography></TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    <Grid container spacing={3}>
                      <Grid item>
                        <FormControlLabel
                          control={(
                            <Checkbox
                              color='primary'
                              checked={DOM_TEST}
                              onChange={(event) => {
                                PREBID.ADAPTMX.TEST_MODE.DOM = event.target.checked
                                setOptions({ ...options, PREBID })
                              }}
                            />
                          )}
                          label='Domestic'
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={(
                            <Checkbox
                              color='primary'
                              checked={INTL_TEST}
                              onChange={(event) => {
                                PREBID.ADAPTMX.TEST_MODE.INTL = event.target.checked
                                setOptions({ ...options, PREBID })
                              }}
                            />
                          )}
                          label='International'
                        />
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
